package com.sddamico.draftmachine.util

import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

/** Decoded value of [name] in the current location's query string, or null when absent. */
fun queryParam(name: String): String? = URLSearchParams(window.location.search).get(name)
